import { render, staticRenderFns } from "./SpendingBanner.vue?vue&type=template&id=698e1254&"
import script from "./SpendingBanner.vue?vue&type=script&lang=js&"
export * from "./SpendingBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports